import { useLazyQuery } from "@apollo/client";
import { useAuthState } from "../../../contexts/auth/auth.provider";
import { useAppState } from "@/contexts/app/app.provider";
import { GET_AD_SPACES } from "../../../graphql/queries/listing";
import { useCallback, useEffect, useState } from "react";
import logger from "../../../../console";
import { Spinner } from "@aqar-app/react-ui";
import withLazyLoad from "../../../hooks/withLazyLoad";
import css from "./.module.scss";

const ImpressionImg = ({ url }) => {
  return (
    <img
      src={url}
      style={{
        display: "none",
      }}
      alt="Impression"
    />
  );
};

const ProfileAdSpaces = () => {
  const LazyImpressionImg = withLazyLoad(ImpressionImg);
  const { token } = useAuthState();
  const { isMobile } = useAppState();
  const [location, setLocation] = useState(undefined);
  const [gettingLocation, setGettingLocation] = useState(true);

  const getUserLocation = useCallback(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const p = position.coords;
          setLocation({
            lat: p.latitude,
            lng: p.longitude,
          });
          setGettingLocation(false);
        },
        (error) => {
          logger.log("Error getting location", error);
          setGettingLocation(false);
        },
      );
    } else {
      logger.log("Geolocation is not supported by this browser.");
      setGettingLocation(false);
    }
  }, []);

  const [getAdSpaces, { data, loading }] = useLazyQuery(GET_AD_SPACES, {
    skip: !token,
    context: {
      token,
    },
    onError: logger.log,
  });

  const adSpaces = JSON.parse(data?.PubServer?.pubDecision || "{}");

  const { decisions } = adSpaces || {};
  const { "listing-space": listingSpace } = decisions || {};
  const { contents } = listingSpace || {};
  const { third_party_impression_tracking_url: trackingUrl } =
    contents?.[0]?.data?.customData || {};

  useEffect(() => {
    if (!navigator.permissions) return setGettingLocation(false);
    navigator.permissions
      .query({ name: "geolocation" })
      .then((result) => {
        if (result.state === "granted") return getUserLocation();
        setGettingLocation(false);
        logger.log("Not Granted Skippong");
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    if (!gettingLocation)
      getAdSpaces({
        variables: {
          ad_types: isMobile ? "user_profile_small" : "user_profile_wide",
          site_id: "web",
          location,
        },
      });
  }, [gettingLocation, location, isMobile]);

  return (
    <div style={{ marginTop: "24px" }}>
      {listingSpace?.contents?.map((content, i) => (
        <a
          key={i}
          href={listingSpace?.clickUrl}
          rel="nofollow"
          target="_blank"
          title=""
        >
          <img
            src={content?.data?.imageUrl}
            style={{
              borderRadius: "5px",
            }}
            alt="Ad Space"
          />
        </a>
      ))}
      {listingSpace?.impressionUrl && (
        <LazyImpressionImg url={listingSpace?.impressionUrl} />
      )}
      {trackingUrl && (
        <LazyImpressionImg
          url={trackingUrl.replace(
            "ord=[timestamp]",
            `ord=${Math.floor(new Date().getTime() / 1000)}`,
          )}
        />
      )}
    </div>
  );
};

export default ProfileAdSpaces;
